//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import moment from 'moment';
import $ from "jquery";

//childrens
import Content from '../childrens/content/.mixins';
import Columns from '../childrens/columns/.mixins';
import CustomSort from '../childrens/customSort/.mixins';

//controllers
import Protocolos_controller from '../../../../../../../../controllers/protocolo';
import Config from '../../../../../../../../controllers/config';

export default class DatasLista extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            filter: false,
            search: true,
            sort: true,
            download: false,
            sortFilterList: false,
            viewColumns: false,
            padding: '5px',
            title: 'Escolha uma data',
            itens: [],
            itensTable: [],
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
            onCellClick: (colData, cellMeta) => {
                this.props.pai.loadData(colData);
            },
            customSort: CustomSort
        }

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);

    }

    componentDidMount() {
        this.loadData();

        $(document).ready(() => {
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 2000);
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 3000);
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 4000);
        });
    }

    async loadData() {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {

            const filters = {
                idFornecedor: this.props.pai.state.fornecedor
            };
            const o_datas = await Protocolos_controller.getProtocoloDatas(token,filters);
            const j_datas = JSON.parse(o_datas.body);

            if (j_datas.status) {
                
                //prepara dados para tabela
                const arrayItens = j_datas.itens.map(e=>{
                    return {DT_AGENDA: e.DT_AGENDA.substr(0, e.DT_AGENDA.indexOf(' '))};
                });

                this.setState({
                    itens: j_datas.itens,
                    itensTable: arrayItens,
                    isLoading: false,
                    columns: Columns,
                });
                
            } else {
                if (
                    j_datas.status == false && 
                    j_datas.message && 
                    j_datas.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

        } catch (error) {
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
            errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            this.child.current.retorno(errorString,'error');
        }
        
    }

    render() {
        return <Content {...this}/>;
    }

}